import styled from 'foundations-theming/utils';
const SystemMessageContent = styled.div.attrs(() => ({
  'data-test-id': 'system-message-content'
})).withConfig({
  displayName: "SystemMessageContent",
  componentId: "i1m8km-0"
})(["flex-grow:1;color:", ";display:flex;align-items:center;padding-left:", ";font-size:", ";line-height:", ";"], ({
  theme
}) => theme.color['text-core-subtle'], ({
  theme
}) => theme.space[400], ({
  theme
}) => theme.space[300], ({
  theme
}) => theme.space[400]);
SystemMessageContent.displayName = 'SystemMessageContent';
export default SystemMessageContent;